<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <!-- <CInput placeholder="Username" autocomplete="username">
                  <template #prepend-content
                    ><CIcon name="cil-user"
                  /></template>
                </CInput> -->
                <CInput
                  placeholder="Email"
                  autocomplete="email"
                  prepend="@"
                  v-model="email"
                />
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="new-password"
                  v-model="password"
                >
                  <template #prepend-content
                    ><CIcon name="cil-lock-locked"
                  /></template>
                </CInput>
                <CInput
                  placeholder="Repeat password"
                  type="password"
                  autocomplete="new-password"
                  class="mb-4"
                  v-model="password_confirm"
                >
                  <template #prepend-content
                    ><CIcon name="cil-lock-locked"
                  /></template>
                </CInput>
                <CButton color="success" block @click="register"
                  >Create Account</CButton
                >
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CModal
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="modalTitle"
        size="sm"
      >
        {{ errorMessage }}
        <template #header> </template>
        <template #footer>
          <CButton @click="myModal = false" color="success">OK</CButton>
        </template>
      </CModal>
    </CContainer>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Register",
  data() {
    return {
      email: "",
      password: "",
      password_confirm: "",

      myModal: false,
      modalTitle: "",
      errorMessage: "",
    };
  },
  methods: {
    register() {
      //validation.
      if (this.email == "") {
        this.modalTitle = "Warning!";
        this.errorMessage = "Please enter the email";
        this.myModal = true;
        return;
      }
      if (this.password == "") {
        this.modalTitle = "Warning!";
        this.errorMessage = "Please enter the password";
        this.myModal = true;
        return;
      }
      if (this.password != this.password_confirm) {
        this.modalTitle = "Warning!";
        this.errorMessage = "Password does not match. Please check.";
        this.myModal = true;
        return;
      }
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          var db = firebase.firestore();
          // db.collection("users")
          //   .doc(user.uid)
          //   .set({
          //     email: this.email,
          //     role: "admin",
          //     isDeleted: false,
          //   })
          //   .then(() => {
          //     console.log("Document successfully written!");
          //   })
          //   .catch((error) => {
          //     console.error("Error writing document: ", error);
          //   });

         
          this.$router.push("/login");
        })
        .catch((error) => {
          var errorCode = error.code;
          console.log("errorCode", errorCode);
          this.modalTitle = "Warning!";
          this.errorMessage = error.message;
          this.myModal = true;
        });
    },
  },
};
</script>
